






import { Vue, Component } from "@/shared/vuepack";
import CommonTab from "@/employer/components/shared/CommonTab.vue";

@Component({
  components: { CommonTab }
})
export default class ProductsTab extends Vue {}
